import { Link, NavLink } from "react-router-dom";
import { selector } from "../api";

export const Sidebar = () => {
  const user = selector.User();
  const isGroup = user.groups.some((element) => {
    if (element === 1) {
      return true;
    }

    return false;
  });

  return (
    <>
      <div className="app-menu navbar-menu">
        <div className="navbar-brand-box">
          <Link to={"/dashboard"}>
            <span className="text-white d-flex flex-column align-items-center">
              <img
                src="assets/images/logo/smz.png"
                alt="SMZ"
                height="110"
                className="mt-3"
              />
              <h5 className="text-white mt-2 mb-3 fw-semibold text-uppercase">
                Shehia Register
              </h5>
            </span>
          </Link>
          <button
            type="button"
            className="btn btn-sm p-0 fs-20 header-item float-end btn-vertical-sm-hover"
            id="vertical-hover"
          >
            <i className="ri-record-circle-line"></i>
          </button>
        </div>

        <div id="scrollbar">
          <div className="container-fluid">
            <div id="two-column-menu"></div>
            <ul className="navbar-nav" id="navbar-nav">
              <li className="nav-item">
                <NavLink to={"/dashboard"} className="nav-link menu-link">
                  <i className="ri-dashboard-2-line"></i>
                  <span data-key="t-dashboards">Dashboards</span>
                </NavLink>
              </li>
              {user.is_staff && (
                <li className="nav-item">
                  <a
                    className="nav-link menu-link"
                    href="#sidebarDictionary"
                    data-bs-toggle="collapse"
                    role="button"
                    aria-expanded="false"
                    aria-controls="sidebarDictionary"
                  >
                    <i className="las la-bars la-lg"></i>
                    <span data-key="t-dictionary">Dictionary</span>
                  </a>
                  <div
                    className="collapse menu-dropdown"
                    id="sidebarDictionary"
                  >
                    <ul className="nav nav-sm flex-column">
                      <li className="nav-item">
                        <NavLink
                          to={"/dictionary"}
                          className="nav-link"
                          data-key="t-dictionary"
                        >
                          Dictionary
                        </NavLink>
                      </li>
                      <li className="nav-item">
                        <NavLink
                          to={"/dictionaryitem"}
                          className="nav-link"
                          data-key="t-items"
                        >
                          Dictionary Items
                        </NavLink>
                      </li>
                    </ul>
                  </div>
                </li>
              )}
              <li className="nav-item">
                <a
                  className="nav-link menu-link"
                  href="#sidebarRegister"
                  data-bs-toggle="collapse"
                  role="button"
                  aria-expanded="false"
                  aria-controls="sidebarRegister"
                >
                  <i className="las la-edit la-lg"></i>
                  <span data-key="t-register">Register</span>
                </a>
                <div className="collapse menu-dropdown" id="sidebarRegister">
                  <ul className="nav nav-sm flex-column">
                    <li className="nav-item">
                      <NavLink
                        to={"/building"}
                        state={{ category: null }}
                        className="nav-link"
                        data-key="t-building"
                      >
                        Buildings
                      </NavLink>
                    </li>
                    <li className="nav-item">
                      <NavLink
                        to={"/kaya"}
                        className="nav-link"
                        data-key="t-kaya"
                      >
                        House Hold
                      </NavLink>
                    </li>
                    <li className="nav-item">
                      <NavLink
                        to={"/member"}
                        className="nav-link"
                        data-key="t-member"
                      >
                        House Hold Member
                      </NavLink>
                    </li>
                    <li className="nav-item">
                      <NavLink
                        to={"/memberdead"}
                        className="nav-link"
                        data-key="t-member"
                      >
                        Dead House Hold Member
                      </NavLink>
                    </li>
                  </ul>
                </div>
              </li>
              {user.is_staff && (
                <li className="nav-item">
                  <a
                    className="nav-link menu-link"
                    href="#sidebarBoundary"
                    data-bs-toggle="collapse"
                    role="button"
                    aria-expanded="false"
                    aria-controls="sidebarDashboards"
                  >
                    <i className="las la-square la-lg"></i>
                    <span data-key="t-boundary">Administrative Level</span>
                  </a>
                  <div className="collapse menu-dropdown" id="sidebarBoundary">
                    <ul className="nav nav-sm flex-column">
                      <li className="nav-item">
                        <NavLink
                          to={"/island"}
                          className="nav-link"
                          data-key="t-island"
                        >
                          Island
                        </NavLink>
                      </li>
                      <li className="nav-item">
                        <NavLink
                          to={"/region"}
                          className="nav-link"
                          data-key="t-region"
                        >
                          Region
                        </NavLink>
                      </li>
                      <li className="nav-item">
                        <NavLink
                          to={"/district"}
                          className="nav-link"
                          data-key="t-district"
                        >
                          District
                        </NavLink>
                      </li>
                      <li className="nav-item">
                        <NavLink
                          to={"/ward"}
                          className="nav-link"
                          data-key="t-ward"
                        >
                          Ward
                        </NavLink>
                      </li>
                      <li className="nav-item">
                        <NavLink
                          to={"/shehia"}
                          className="nav-link"
                          data-key="t-shehia"
                        >
                          Shehia
                        </NavLink>
                      </li>
                      <li className="nav-item">
                        <NavLink
                          to={"/zone"}
                          className="nav-link"
                          data-key="t-zone"
                        >
                          Zone
                        </NavLink>
                      </li>
                      <li className="nav-item">
                        <NavLink
                          to={"/street"}
                          className="nav-link"
                          data-key="t-street"
                        >
                          Street / Road
                        </NavLink>
                      </li>
                      <li className="nav-item">
                        <NavLink
                          to={"/leader"}
                          className="nav-link"
                          data-key="t-leader"
                        >
                          Leader
                        </NavLink>
                      </li>
                    </ul>
                  </div>
                </li>
              )}
              {!user.is_staff && user.admin_access === "Shehia" && (
                <li className="nav-item">
                  <a
                    className="nav-link menu-link"
                    href="#sidebarShehiaBoundary"
                    data-bs-toggle="collapse"
                    role="button"
                    aria-expanded="false"
                    aria-controls="sidebarShehiaBoundary"
                  >
                    <i className="las la-square la-lg"></i>
                    <span data-key="t-boundary">Administrative Level</span>
                  </a>
                  <div className="collapse menu-dropdown" id="sidebarShehiaBoundary">
                    <ul className="nav nav-sm flex-column">
                      <li className="nav-item">
                        <NavLink to={"/zone"} className="nav-link" data-key="t-zone">
                          Zone
                        </NavLink>
                      </li>
                      <li className="nav-item">
                        <NavLink to={"/street"} className="nav-link" data-key="t-street">
                          Street / Road
                        </NavLink>
                      </li>
                    </ul>
                  </div>
                </li>
              )}
              {user.is_staff && (
                <li className="nav-item">
                  <a
                    className="nav-link menu-link"
                    href="#sidebarAuth"
                    data-bs-toggle="collapse"
                    role="button"
                    aria-expanded="false"
                    aria-controls="sidebarAuth"
                  >
                    <i className="ri-account-circle-line"></i>
                    <span data-key="t-authentication">System User</span>
                  </a>
                  <div className="collapse menu-dropdown" id="sidebarAuth">
                    <ul className="nav nav-sm flex-column">
                      <li className="nav-item">
                        <NavLink
                          to={"/user"}
                          className="nav-link"
                          data-key="t-user"
                        >
                          System User
                        </NavLink>
                      </li>
                      <li className="nav-item">
                        <NavLink
                          to={"/role"}
                          className="nav-link"
                          data-key="t-role"
                        >
                          Roles &amp; Permissions
                        </NavLink>
                      </li>
                    </ul>
                  </div>
                </li>
              )}
              <li className="nav-item">
                <Link
                  to={"/map"}
                  state={{ type: "type", id: 0 }}
                  className="nav-link menu-link"
                >
                  <i className="las la-map-marked-alt la-lg"></i>
                  <span data-key="t-map">Map</span>
                </Link>
              </li>
              <li className="nav-item">
                <a
                  className="nav-link menu-link"
                  href="#sidebarReport"
                  data-bs-toggle="collapse"
                  role="button"
                  aria-expanded="false"
                  aria-controls="sidebarDashboards"
                >
                  <i className="las la-clipboard-list la-lg"></i>
                  <span data-key="t-boundary">Summary Report</span>
                </a>
                <div className="collapse menu-dropdown" id="sidebarReport">
                  <ul className="nav nav-sm flex-column">
                    <li className="nav-item">
                      <NavLink
                        to={"/statistics-dashboard"}
                        className="nav-link"
                        data-key="t-statistics-dashboard"
                      >
                        Statistics Dashboard
                      </NavLink>
                    </li>
                    <li className="nav-item">
                      <NavLink
                        to={"/vital-report"}
                        className="nav-link"
                        data-key="t-vital-report"
                      >
                        Vital Statistical Report
                      </NavLink>
                    </li>
                    <li className="nav-item">
                      <NavLink
                        to={"/report1"}
                        className="nav-link"
                        data-key="t-report1"
                      >
                        Demographic Report
                      </NavLink>
                    </li>
                    <li className="nav-item">
                      <NavLink
                        to={"/report2"}
                        className="nav-link"
                        data-key="t-report2"
                      >
                        Education &amp; Disability Report
                      </NavLink>
                    </li>
                    <li className="nav-item">
                      <NavLink
                        to={"/report3"}
                        className="nav-link"
                        data-key="t-report3"
                      >
                        Socio-Economic &amp; Health Report
                      </NavLink>
                    </li>
                    <li className="nav-item">
                      <NavLink
                        to={"/settlement-overview"}
                        className="nav-link"
                        data-key="t-settlement"
                      >
                        Settlement Overview
                      </NavLink>
                    </li>
                    <li className="nav-item">
                      <NavLink
                        to={"/report-members-live"}
                        className="nav-link"
                        data-key="t-members-live"
                      >
                        Members List
                      </NavLink>
                    </li>
                    <li className="nav-item">
                      <NavLink
                        to={"/report-members-dead"}
                        className="nav-link"
                        data-key="t-members-dead"
                      >
                        Deceased List
                      </NavLink>
                    </li>
                  </ul>
                </div>
              </li>
              <li className="nav-item">
                <a className="nav-link menu-link" href="#sidebarAuth"></a>
              </li>
              <li className="nav-item">
                <a className="nav-link menu-link" href="#sidebarAuth"></a>
              </li>
              <li className="nav-item">
                <a className="nav-link menu-link" href="#sidebarAuth"></a>
              </li>
              <li className="nav-item">
                <a className="nav-link menu-link" href="#sidebarAuth"></a>
              </li>
              <li className="nav-item">
                <a className="nav-link menu-link" href="#sidebarAuth"></a>
              </li>
              <li className="nav-item">
                <a className="nav-link menu-link" href="#sidebarAuth"></a>
              </li>
              <li className="nav-item">
                <a className="nav-link menu-link" href="#sidebarAuth"></a>
              </li>
              <li className="nav-item">
                <a className="nav-link menu-link" href="#sidebarAuth"></a>
              </li>
              <li className="nav-item">
                <a className="nav-link menu-link" href="#sidebarAuth"></a>
              </li>
              <li className="nav-item">
                <a className="nav-link menu-link" href="#sidebarAuth"></a>
              </li>
              <li className="nav-item">
                <a className="nav-link menu-link" href="#sidebarAuth"></a>
              </li>
              <li className="nav-item">
                <a className="nav-link menu-link" href="#sidebarAuth"></a>
              </li>
              <li className="nav-item">
                <a className="nav-link menu-link" href="#sidebarAuth"></a>
              </li>
              <li className="nav-item">
                <a className="nav-link menu-link" href="#sidebarAuth"></a>
              </li>
              <li className="nav-item">
                <a className="nav-link menu-link" href="#sidebarAuth"></a>
              </li>
              <li className="nav-item">
                <a className="nav-link menu-link" href="#sidebarAuth"></a>
              </li>
              <li className="nav-item">
                <a className="nav-link menu-link" href="#sidebarAuth"></a>
              </li>
              <li className="nav-item">
                <a className="nav-link menu-link" href="#sidebarAuth"></a>
              </li>
              <li className="nav-item">
                <a className="nav-link menu-link" href="#sidebarAuth"></a>
              </li>
              <li className="nav-item">
                <a className="nav-link menu-link" href="#sidebarAuth"></a>
              </li>
              <li className="nav-item">
                <a className="nav-link menu-link" href="#sidebarAuth"></a>
              </li>
              <li className="nav-item">
                <a className="nav-link menu-link" href="#sidebarAuth"></a>
              </li>
              <li className="nav-item">
                <a className="nav-link menu-link" href="#sidebarAuth"></a>
              </li>
              <li className="nav-item">
                <a className="nav-link menu-link" href="#sidebarAuth"></a>
              </li>
              <li className="nav-item">
                <a className="nav-link menu-link" href="#sidebarAuth"></a>
              </li>
              <li className="nav-item">
                <a className="nav-link menu-link" href="#sidebarAuth"></a>
              </li>
              <li className="nav-item">
                <a className="nav-link menu-link" href="#sidebarAuth"></a>
              </li>
              <li className="nav-item">
                <a className="nav-link menu-link" href="#sidebarAuth"></a>
              </li>
            </ul>
          </div>
        </div>

        <div className="sidebar-background"></div>
      </div>

      <div className="vertical-overlay"></div>
    </>
  );
};
